
/**
 * erp系统显示水印
 * 首先下载watermark-dom目前版本2.3.0
 * 在入口文件引入该文件即可(位置在自定义路由之后因为 import router from '@/router')
 * 大家有更优方案，可以一起分享共同进步
 */
import router from '@/router'
import watermark from 'watermark-dom'

router.afterEach((to, from) => {
  // 如果不一样需要改一下呦
  const userinfo = JSON.parse(localStorage.getItem('user'))
  let str
  if (userinfo && userinfo.employeeBo) {
    str = `${userinfo.employeeBo.employeeNumber}-${userinfo.employeeBo.trueName}-${userinfo.employeeBo.mobile}`
  } else {
    str = ''
  }
  const optionsWat = {
  // watermark_id: 'wm_div_id', // 水印总体的id
  // watermark_prefix: 'mask_div_id', // 小水印的id前缀
    watermark_txt: str || '男神', // 水印的内容
    watermark_x: 20, // 水印起始位置x轴坐标
    watermark_y: 40, // 水印起始位置Y轴坐标
    // watermark_rows: 2, // 水印行数
    // watermark_cols: 2, // 水印列数
    watermark_x_space: 100, // 水印x轴间隔
    watermark_y_space: 100, // 水印y轴间隔
    watermark_font: '微软雅黑', // 水印字体
    watermark_color: 'black', // 水印字体颜色
    watermark_fontsize: '18px', // 水印字体大小
    watermark_alpha: 0.15, // 水印透明度，要求设置在大于等于0.005
    watermark_width: 500, // 水印宽度
    watermark_height: 200, // 水印长度
    watermark_angle: 18 // 水印倾斜度数
  }
  if (!to.path.includes('login')) {
    setTimeout(() => {
      watermark.init(optionsWat)
    }, 800)
  } else {
    setTimeout(() => {
      watermark.load({ watermark_txt: ' ' })
      watermark.remove()
    }, 800)
  }
})
